<template>
  <div id="clients" v-if="showWindow">
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
export default {
  components: {   
    tableView
  },
  data() {
    
    let data = {
      params:{},
      endPoint:'clients',
      filters: {
        brokers: true,
        ver_status: true,
        country: true
      }
    }    
      data.columnDefs= JSON.parse(localStorage.getItem('clientColumns'))
    return data;
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/clients'){
        return true;
      }
      return false;
    },
  }
}

</script>